<template>
  <v-autocomplete
    v-bind="$attrs"
    @input="updateFieldValue(name, $event)"
    :value="currentValue"
    :messages="[error]"
    :error="!!error"
    :items="items"
    :loading="isLoading"
    :outlined="outlined"
    :search-input.sync="search"
    color="accent"
    :item-text="item_name"
    :item-value="item_value"
    hide-no-data
    hide-selected
    clearable
    no-data-text="No results found/loaded yet"
    placeholder="Start typing to Search"
    :prepend-inner-icon="icon"
  >
  </v-autocomplete>
</template>

<script>
import baseInput from "./baseInput";
import debounce from "lodash/debounce";

export default {
  props: {
    url: { required: true, type: String },
    icon: { default: "mdi-database-search", type: String },
    outlined: { default: true, type: Boolean },
    item_name: { required: true, type: String },
    item_value: { required: true, type: String },
  },
  mixins: [baseInput],
  data: () => ({
    items: [],
    isLoading: false,
    search: null,
  }),

  computed: {},

  watch: {
    search(value) {
      return this.searchResults(value);
    },
  },
  methods: {
    searchResults: debounce(function (value) {
      if (this.isLoading || !value) return;

      this.isLoading = true;

      // Lazily load input items
      this.$http
        .get(`${this.url}?search=${value}`)
        .then(({ data, total }) => {
          this.count = total;
          this.items = data;
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          // console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }, 500),
  },
};
</script>
